@for (toast of toasts$ | async; track toast) {
	<ngb-toast
		[header]="toast.header"
		[autohide]="toast.autohide"
		[delay]="toast.delay || 5000"
		(hidden)="removeToast(toast)"
		[class]="toast.classname"
		>{{ toast.body }}
	</ngb-toast>
}
